import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = []
  static values = {
    expandedIds: Array
  }

  toggle(event) {
    const element = event.currentTarget
    const claimId = element.dataset.claimId
    const claimBox = element.closest('[data-expandable-claims-target="claimBox"]')

    const content = claimBox.querySelector(`[data-expandable-claims-target="content${claimId}"]`)
    const icon = claimBox.querySelector(`[data-expandable-claims-target="icon${claimId}"]`)
    const includeFlag = claimBox.querySelector(`[data-expandable-claims-target="includeFlag${claimId}"]`)

    const isExpanded = !content.classList.contains('hidden')

    if (isExpanded) {
      // Collapse
      content.classList.add('hidden')
      icon.style.transform = 'rotate(0deg)'
      includeFlag.value = 'false'

      // Clear the input values
      const memberBalance = claimBox.querySelector(`[data-expandable-claims-target="memberBalance${claimId}"]`)
      const balanceAmount = claimBox.querySelector(`[data-expandable-claims-target="balanceAmount${claimId}"]`)
      if (memberBalance) memberBalance.value = ''
      if (balanceAmount) balanceAmount.value = ''
    } else {
      // Expand
      content.classList.remove('hidden')
      icon.style.transform = 'rotate(45deg)'
      includeFlag.value = 'true'
    }
  }

  preventToggle(event) {
    // This method is called when clicking the link, to prevent the toggle from firing
    // The event propagation is already stopped in the HTML with :stop modifier
  }
}

